import { Sidebar, Menu, MenuItem, useProSidebar } from "react-pro-sidebar";
import { useEffect, useState } from "react";
import useWindowSize from "./useWindowSize";
import Properties from "../pages/devcieDetailView/Properties";
import OverView from "../pages/devcieDetailView/OverView";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { useNavigate } from "react-router-dom";
import DriverApp from "../pages/devcieDetailView/DriverApp";
import TireWeight from "../pages/devcieDetailView/TireWeight";
import VehicleManagement from "../pages/devcieDetailView/VehicleManagement";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function SideBarTires({ children, device }) {
  const { collapseSidebar, collapsed } = useProSidebar(); // Use collapsed state
  const [selectedComponent, setSelectedComponent] = useState(
    children[0]?.component || null
  );
  const windowSize = useWindowSize();
  const [isMobile] = useState(windowSize[0] < 992);
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobile) collapseSidebar();
  }, [isMobile, collapseSidebar]);

  const handleMenuItemClick = (component) => {
    setSelectedComponent(component);
  };

  const BackToMap = () => {
    navigate("/devices", { replace: true });
  };

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case "VehicleManagement":
        return <VehicleManagement device={device} />;
      case "OverView":
        return <OverView device={device} />;
      case "TireWeight":
        return <TireWeight device={device} />;
      case "Properties":
        return <Properties device={device} />;
      case "DriverApp":
        return <DriverApp device={device} />;
      default:
        return null;
    }
  };

  return (
    <div
      id="app"
      className="mainWidthTires"
      style={{
        height: "100vh",
        display: "flex",
        position: "fixed",
        width: isMobile ? "100%" : "83%",
      }}
    >
      <Sidebar style={{ height: "100vh" }}>
        <Menu>
          <MenuItem
            icon={collapsed ? <ArrowForwardIosIcon /> : <ArrowBackIosNewIcon />}
            onClick={() => {
              collapseSidebar();
            }}
            style={{ textAlign: "center" }}
          >
            <font className="deviceNameMenu">{device?.name}</font>
          </MenuItem>
          {children.map((child, index) => (
            <MenuItem
              key={index}
              icon={child.icon}
              onClick={() => handleMenuItemClick(child.component)}
            >
              {child.name}
            </MenuItem>
          ))}
          <div style={{ flex: "1" }} />{" "}
          <MenuItem icon={<ArrowCircleLeftOutlinedIcon />} onClick={BackToMap}>
            {"Map "}
          </MenuItem>
        </Menu>
      </Sidebar>
      <main
        style={{
          position: "relative",
          width: "100%",
          overflowY: "scroll",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {renderSelectedComponent()}
      </main>
    </div>
  );
}

export default SideBarTires;